import "./BusinessDirectory.module.css";
import Header from "@/reusable_sections/Header";
import BusinessDirectoryHeader from "./sections/BusinessDirectoryHeader";
import BusinessGridWithFiltering from "./sections/BusinessGridWithFiltering";
import Footer from "@/reusable_sections/Footer";
export default function BusinessDirectoryPage() {
  return <div>
      <Header />
      <BusinessDirectoryHeader />
      <BusinessGridWithFiltering />
      <Footer />
    </div>;
}